"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.REINITCURVES = exports.REINITPRESETS = exports.REINITAVERAGES = exports.REINITMULTS = exports.REINITGLOBALS = exports.REINITCALIBRATION = exports.DISCONNECT = exports.CONNECT = exports.SAVEPRESET = exports.LOADPRESET = exports.GETPRESET = exports.SAVEUSERCURVE = exports.GETUSERCURVE = exports.SETTHRESHOLDMULT = exports.GETTHRESHOLDMULT = exports.SETHIGHMULT = exports.SETLOWMULT = exports.GETHIGHMULT = exports.GETHIGHMULTS = exports.GETLOWMULT = exports.GETLOWMULTS = exports.SETNEGATIVEVELOCITYOFFSET = exports.GETNEGATIVEVELOCITYOFFSET = exports.GETNEGATIVEVELOCITYOFFSETS = exports.GETBARGAINS = exports.CROSSTALKVELOCITYSCALE = exports.CROSSTALKTIMEWINDOW = exports.BUTTONPRESETMODE = exports.LOADGLOBALS = exports.SAVEGLOBALS = exports.GETGLOBALS = exports.SETCALIBRATIONGAIN = exports.GETCALIBRATIONGAIN = exports.SETCALIBRATION = exports.GETCALIBRATION = exports.GETTARES = exports.DEVICEMODE = exports.VERSIONS = exports.BOOTLOADER = void 0;
const BOOTLOADER = '/fw/bootloader';
exports.BOOTLOADER = BOOTLOADER;
const VERSIONS = '/fw/r/version';
exports.VERSIONS = VERSIONS;
const DEVICEMODE = '/fw/w/mode';
exports.DEVICEMODE = DEVICEMODE;
const GETTARES = '/fw/r/tares';
exports.GETTARES = GETTARES;
const GETCALIBRATION = '/cb/read';
exports.GETCALIBRATION = GETCALIBRATION;
const SETCALIBRATION = '/cb/save';
exports.SETCALIBRATION = SETCALIBRATION;
const GETCALIBRATIONGAIN = '/g/r/calibrationGain';
exports.GETCALIBRATIONGAIN = GETCALIBRATIONGAIN;
const SETCALIBRATIONGAIN = '/g/w/calibrationGain';
exports.SETCALIBRATIONGAIN = SETCALIBRATIONGAIN;
const GETGLOBALS = '/g/read';
exports.GETGLOBALS = GETGLOBALS;
const SAVEGLOBALS = '/g/save';
exports.SAVEGLOBALS = SAVEGLOBALS;
const LOADGLOBALS = '/g/load';
exports.LOADGLOBALS = LOADGLOBALS;
const BUTTONPRESETMODE = '/g/w/buttonPresetMode';
exports.BUTTONPRESETMODE = BUTTONPRESETMODE;
const CROSSTALKTIMEWINDOW = '/g/w/crosstalkTimeWindow';
exports.CROSSTALKTIMEWINDOW = CROSSTALKTIMEWINDOW;
const CROSSTALKVELOCITYSCALE = '/g/w/crosstalkVelocityScale';
exports.CROSSTALKVELOCITYSCALE = CROSSTALKVELOCITYSCALE;
const GETBARGAINS = '/g/r/barGains';
exports.GETBARGAINS = GETBARGAINS;
const GETNEGATIVEVELOCITYOFFSETS = '/g/r/negativeVelocityOffsets';
exports.GETNEGATIVEVELOCITYOFFSETS = GETNEGATIVEVELOCITYOFFSETS;
const GETNEGATIVEVELOCITYOFFSET = '/g/r/negativeVelocityOffset';
exports.GETNEGATIVEVELOCITYOFFSET = GETNEGATIVEVELOCITYOFFSET;
const SETNEGATIVEVELOCITYOFFSET = '/g/w/negativeVelocityOffset';
exports.SETNEGATIVEVELOCITYOFFSET = SETNEGATIVEVELOCITYOFFSET;
const GETLOWMULTS = '/g/r/barLowMults';
exports.GETLOWMULTS = GETLOWMULTS;
const GETLOWMULT = '/g/r/barLowMult';
exports.GETLOWMULT = GETLOWMULT;
const GETHIGHMULTS = '/g/r/barHighMults';
exports.GETHIGHMULTS = GETHIGHMULTS;
const GETHIGHMULT = '/g/r/barHighMult';
exports.GETHIGHMULT = GETHIGHMULT;
const SETLOWMULT = '/g/w/barLowMult';
exports.SETLOWMULT = SETLOWMULT;
const SETHIGHMULT = '/g/w/barHighMult';
exports.SETHIGHMULT = SETHIGHMULT;
const GETTHRESHOLDMULT = '/g/r/thresholdMult';
exports.GETTHRESHOLDMULT = GETTHRESHOLDMULT;
const SETTHRESHOLDMULT = '/g/w/thresholdMult';
exports.SETTHRESHOLDMULT = SETTHRESHOLDMULT;
const GETUSERCURVE = '/uc/read';
exports.GETUSERCURVE = GETUSERCURVE;
const SAVEUSERCURVE = '/uc/save';
exports.SAVEUSERCURVE = SAVEUSERCURVE;
const GETPRESET = '/p/read';
exports.GETPRESET = GETPRESET;
const LOADPRESET = '/p/load';
exports.LOADPRESET = LOADPRESET;
const SAVEPRESET = '/p/save';
exports.SAVEPRESET = SAVEPRESET;
const CONNECT = '/e/connect';
exports.CONNECT = CONNECT;
const DISCONNECT = '/e/disconnect';
exports.DISCONNECT = DISCONNECT;
const REINITCALIBRATION = '/cb/reInit';
exports.REINITCALIBRATION = REINITCALIBRATION;
const REINITGLOBALS = '/g/reInit';
exports.REINITGLOBALS = REINITGLOBALS;
const REINITMULTS = '/g/reInitMults';
exports.REINITMULTS = REINITMULTS;
const REINITAVERAGES = '/g/reInitAverages';
exports.REINITAVERAGES = REINITAVERAGES;
const REINITPRESETS = '/p/reInit';
exports.REINITPRESETS = REINITPRESETS;
const REINITCURVES = '/uc/reInit';
exports.REINITCURVES = REINITCURVES;